import Vue from 'vue'
import Vuex from 'vuex'

import common from './common'
import cliente from './cliente'
import credenciada from './credenciada'
import empresa from './empresa'
import ltcat from './ltcat'
import usuario from './usuario'

Vue.use(Vuex)
/*
 * If not building with SSR mode, you can
 * directly export the Store instantiation
 */

export default function (/* { ssrContext } */) {
  const Store = new Vuex.Store({
    modules: {
   		common,
      cliente,
      credenciada,
      empresa,
      ltcat,
      usuario
    }
  })

  return Store
}



// WEBPACK FOOTER //
// ./src/store/index.js